import React, { useState } from 'react';
import { BOOKS } from '../data';
import { getCategoryIcon, IconPlus, IconArrow } from './Icons';
import { saveField, loadUserData } from '../supabase';

const CATS = [
  { id: 'all', label: 'All' },
  { id: 'mindfulness', label: 'Mindfulness' },
  { id: 'habits', label: 'Habits' },
  { id: 'mental', label: 'Mental' },
  { id: 'spirituality', label: 'Spirituality' },
  { id: 'fitness', label: 'Fitness' },
  { id: 'nutrition', label: 'Nutrition' },
  { id: 'success', label: 'Growth' },
];

export default function Library({ userId }) {
  const [open, setOpen] = useState(null);
  const [cat, setCat] = useState('all');
  const [search, setSearch] = useState('');
  const [openBad, setOpenBad] = useState({});
  const [addedHabits, setAddedHabits] = useState([]);

  const filtered = BOOKS.filter(b =>
    (cat === 'all' || b.category === cat) &&
    (b.title.toLowerCase().includes(search.toLowerCase()) || b.author.toLowerCase().includes(search.toLowerCase()))
  );

  async function addHabit(book, habit) {
    const key = `${book.id}_${habit.name}`;
    if (addedHabits.includes(key)) return;
    setAddedHabits(prev => [...prev, key]);
    const newHabit = { id: `lib_${Date.now()}_${Math.random()}`, name: habit.name, sub: habit.summary, when: '', frequency: '', started: new Date().toISOString().slice(0, 10) };
    if (userId) {
      const data = await loadUserData(userId);
      const existing = data?.habits || [];
      await saveField(userId, 'habits', [...existing, newHabit]);
    } else {
      const existing = JSON.parse(localStorage.getItem('bhn_custom_habits') || '[]');
      localStorage.setItem('bhn_custom_habits', JSON.stringify([...existing, newHabit]));
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', width: '100%' }}>
      <div className="top-bar">
        <div className="brand-small">Library</div>
        <div className="screen-title">Books & Practices</div>
      </div>
      <div className="screen-body" style={{ width: '100%' }}>
        {/* Intro */}
        <div style={{ fontSize: 13, color: '#777', lineHeight: 1.7, marginBottom: 16, padding: '0 0 16px', borderBottom: '1px solid #F5F3F0' }}>
          A collection of wellness books. Add practices from any book directly to your daily rhythm.
        </div>

        <input className="search-input" placeholder="Search books or authors..." value={search} onChange={e => setSearch(e.target.value)} />
        <div className="cat-pills">
          {CATS.map(c => (
            <div key={c.id} className={`cat-pill ${cat === c.id ? 'active' : ''}`} onClick={() => setCat(c.id)}>{c.label}</div>
          ))}
        </div>

        {filtered.map(book => (
          <div key={book.id}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '14px 0', borderBottom: open === book.id ? 'none' : '1px solid #F5F3F0', cursor: 'pointer' }} onClick={() => setOpen(open === book.id ? null : book.id)}>
              <div style={{ width: 42, height: 56, borderRadius: 5, background: book.bg, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {getCategoryIcon(book.category, 20, '#666')}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#111', letterSpacing: '-.1px' }}>{book.title}</div>
                <div style={{ fontSize: 11, color: '#A09888', fontWeight: 500, marginTop: 2 }}>{book.author}</div>
              </div>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
                <path d={open === book.id ? "M18 15l-6-6-6 6" : "M6 9l6 6 6-6"} stroke="#C8C4BE" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </div>

            {open === book.id && (
              <div style={{ paddingBottom: 16, borderBottom: '1px solid #F5F3F0' }}>
                <div style={{ fontSize: 12, color: '#666', lineHeight: 1.75, marginBottom: 16 }}>{book.summary}</div>

                {/* Habits — shown immediately, no extra tap */}
                <div style={{ fontSize: 10, letterSpacing: '.12em', textTransform: 'uppercase', color: '#3A6A2A', fontWeight: 700, marginBottom: 10 }}>
                  Habits to build — tap + to add to your tracker
                </div>
                {book.habits.map((h, i) => {
                  const key = `${book.id}_${h.name}`;
                  const isAdded = addedHabits.includes(key);
                  return (
                    <div key={i} style={{ padding: '12px 0', borderBottom: '1px solid #F8F6F4' }}>
                      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 10, marginBottom: 6 }}>
                        <div style={{ fontSize: 13, fontWeight: 600, color: '#111', flex: 1, letterSpacing: '-.1px' }}>{h.name}</div>
                        <button
                          onClick={() => addHabit(book, h)}
                          style={{ flexShrink: 0, padding: '5px 12px', background: isAdded ? '#3A6A2A' : 'white', border: `1px solid ${isAdded ? '#3A6A2A' : '#E0DDD8'}`, borderRadius: 7, fontSize: 11, fontWeight: 600, color: isAdded ? 'white' : '#3A6A2A', cursor: isAdded ? 'default' : 'pointer', display: 'flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap' }}
                        >
                          {isAdded ? '✓ Added' : <><IconPlus size={11} color="#3A6A2A" /> Add</>}
                        </button>
                      </div>
                      <div style={{ fontSize: 12, color: '#777', lineHeight: 1.65, marginBottom: 8 }}>{h.summary}</div>
                      <div style={{ background: '#FAFAF8', borderRadius: 8, padding: '10px 12px', borderLeft: '2px solid #D4C4A0' }}>
                        <div style={{ fontSize: 10, letterSpacing: '.1em', textTransform: 'uppercase', color: '#A09888', marginBottom: 4, fontWeight: 600 }}>Daily practice</div>
                        <div style={{ fontSize: 12, color: '#444', lineHeight: 1.7 }}>{h.prompt}</div>
                      </div>
                    </div>
                  );
                })}

                {/* Bad habits */}
                {book.badHabits && book.badHabits.length > 0 && (
                  <div style={{ marginTop: 12 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', padding: '10px 0', borderTop: '1px solid #F5F3F0' }} onClick={() => setOpenBad(prev => ({ ...prev, [book.id]: !prev[book.id] }))}>
                      <div style={{ fontSize: 10, letterSpacing: '.12em', textTransform: 'uppercase', color: '#8B4040', fontWeight: 700 }}>Habits to replace ({book.badHabits.length})</div>
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none"><path d={openBad[book.id] ? "M18 15l-6-6-6 6" : "M6 9l6 6 6-6"} stroke="#C8C4BE" strokeWidth="1.5" strokeLinecap="round"/></svg>
                    </div>
                    {openBad[book.id] && book.badHabits.map((h, i) => (
                      <div key={i} style={{ background: '#FDF8F8', borderRadius: 8, padding: '10px 12px', marginBottom: 8, borderLeft: '2px solid #D4A0A0' }}>
                        <div style={{ fontSize: 10, letterSpacing: '.1em', textTransform: 'uppercase', color: '#8B4040', marginBottom: 4, fontWeight: 600 }}>Replace: {h.name}</div>
                        <div style={{ fontSize: 12, color: '#444', lineHeight: 1.7 }}>{h.replace}</div>
                      </div>
                    ))}
                  </div>
                )}

                <a href={`https://www.amazon.com/s?k=${encodeURIComponent(book.title + ' ' + book.author)}`} target="_blank" rel="noopener noreferrer"
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11, color: '#A09888', fontWeight: 600, textDecoration: 'none', marginTop: 12, borderBottom: '1px solid #E0DDD8', paddingBottom: 2 }}>
                  Find on Amazon <IconArrow size={11} color="#A09888" />
                </a>
              </div>
            )}
          </div>
        ))}

        <div style={{ fontSize: 11, color: '#C8C4BE', textAlign: 'center', marginTop: 24, lineHeight: 1.75, padding: '20px 8px 0', borderTop: '1px solid #F5F3F0' }}>
          All book summaries and habit prompts are original content inspired by the works of each author. Be Here Now is not affiliated with any author or publisher.
        </div>
      </div>
    </div>
  );
}
